import axios, { AxiosInstance, AxiosResponse, CreateAxiosDefaults } from 'axios';
import { resetPassportSession } from './resetPassportSession';

export default function createApiInstance(API_URL: string): AxiosInstance {
    const instanceConfig: CreateAxiosDefaults = {
        withCredentials: true,
        baseURL: API_URL,
        headers: {
            'Content-Type': 'application/json',
        },
    };

    const apiInstance: AxiosInstance = axios.create(instanceConfig);

    apiInstance.interceptors.response.use(
        (response: AxiosResponse): AxiosResponse => {
            return response;
        },
        async (error) => {
            if (error.response.status === 401 || error.response.status === 403) {
                resetPassportSession();
            }

            throw error;
        },
    );

    return apiInstance;
}
